import React from 'react';

const FullScreenLoader = () => (
  <div className="loading-screen" data-testid="loading-screen">
    <div className="loader" />
  </div>
);

export default FullScreenLoader;

